import { defaultDeepLinkRouteConfig, LDFlags } from "@/constants/FeatureFlags";
import type {
  DeepLinkRouteConfig,
  FeatureFlags,
} from "@/constants/FeatureFlags";
import useLaunchDarkly from "@/crossPlatform/LaunchDarkly";

const useFeatureFlags = (): FeatureFlags => {
  const { useBoolVariation, useStringVariation, useTypedVariation } =
    useLaunchDarkly();

  const configureDeepLinkRoutes = useTypedVariation<DeepLinkRouteConfig>(
    LDFlags.configureDeepLinkRoutes,
    defaultDeepLinkRouteConfig,
  );

  const appVideoResourcesPrefixUrl = useStringVariation(
    LDFlags.appVideoResourcesPrefixUrl,
    "",
  );
  const isAndroidSecurityScreenDisabled = useBoolVariation(
    LDFlags.isAndroidSecurityScreenDisabled,
    false,
  );
  const isAssignAssessmentsToProxySupportsEnabled = useBoolVariation(
    LDFlags.isAssignAssessmentsToProxySupportsEnabled,
    false,
  );

  const isBaselineAssessmentsEnabled = useBoolVariation(
    LDFlags.isBaselineAssessmentsEnabled,
    true,
  );

  const appMinimumSupportedVersion = useStringVariation(
    LDFlags.appMinimumSupportedVersion,
    "1.24.0",
  );

  const isMyEquipV2LoginEnabled = useBoolVariation(
    LDFlags.isMyEquipV2LoginEnabled,
    false,
  );

  const isAddToCalendarEnabled = useBoolVariation(
    LDFlags.isAddToCalendarEnabled,
    false,
  );

  const isGroupClassRedesignEnabled = useBoolVariation(
    LDFlags.isGroupClassRedesignEnabled,
    true,
  );

  const isOnboardingV2Enabled = useBoolVariation(
    LDFlags.isOnboardingV2Enabled,
    false,
  );

  return {
    appMinimumSupportedVersion,
    appVideoResourcesPrefixUrl,
    configureDeepLinkRoutes,
    // https://teamequip.atlassian.net/browse/PT-1441
    isAddToCalendarEnabled,
    isAndroidSecurityScreenDisabled,
    isAssignAssessmentsToProxySupportsEnabled,
    isBaselineAssessmentsEnabled,
    isGroupClassRedesignEnabled,
    isMyEquipV2LoginEnabled,
    isOnboardingV2Enabled,
  };
};

export default useFeatureFlags;
